export default {
  iconTextItem: ['总共', '个图标'],
}
